var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 97,
    viewBox: "0 0 137 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.965 45.8073L91.3241 2.16651C89.9058 0.74818 87.6001 0.74818 86.1818 2.16651C84.7634 3.58484 84.7634 5.89051 86.1818 7.30884L123.611 44.7381L5.1045 44.7381C3.09703 44.7381 1.46777 46.3673 1.46777 48.3748C1.46777 50.3823 3.09703 52.0115 5.1045 52.0115L123.611 52.0115L86.1818 89.4408C84.7634 90.8591 84.7634 93.1648 86.1818 94.5831C86.8946 95.2959 87.8256 95.645 88.7566 95.645C89.6876 95.645 90.6186 95.2886 91.3314 94.5831L134.972 50.9423C136.39 49.524 136.39 47.2183 134.972 45.8L134.965 45.8073Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.eab52dab6308ecc135f08e41173c562c.svg";
export { ForwardRef as ReactComponent };